module.exports = __webpack_public_path__ + "src/assets/img/logo_heng@2x.e296fcff.png";